/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.product-slider__swiper')

  if (!sliders.length) return

  sliders.forEach(function (slider) {
    const section = slider.closest('section')
    if (!section) return

    const sectionId = section.id

    const swiperInstance = new Swiper(slider, {
      spaceBetween: 40,
      slidesPerView: 'auto',
      grabCursor: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous product',
        nextSlideMessage: 'Next product'
      },
      navigation: {
        nextEl: '#' + sectionId + ' .product-slider__nav-btn--next',
        prevEl: '#' + sectionId + ' .product-slider__nav-btn--prev'
      }
    })

    // Store reference for potential cleanup
    slider.swiperInstance = swiperInstance
  })
})
